import { PipelineStepInstance } from './pipelineBuilder.types'
import { getCatalogEntry } from './stepCatalog'

export function getStepDisplayLabel(step: PipelineStepInstance): string {
    const catalog = getCatalogEntry(step.type)
    const label = step.config?.instance_label
    if (typeof label === 'string' && label.trim()) {
        return label.trim()
    }
    return catalog.label
}
